import { makeAutoObservable } from "mobx";
import { ProposalsRequest } from "../requests/ProposalsRequest.js";
import { ProposalsTypeRequest } from "../requests/ProposalsTypeRequest.js";
import { PROPOSAL_TYPE } from "../utils/constants.js";

class ProposalTypeStore {
  showCreateModal = false;
  getProposalTypes = () => {
    return new Promise((resolve, reject) => {
      ProposalsTypeRequest.getProposalTypes()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  getAllProposalTypes = () => {
    return new Promise((resolve, reject) => {
      ProposalsTypeRequest.getAllProposalTypes()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  createProposalType = (name, contentKey, approvalTemplateCode) => {
    return new Promise((resolve, reject) => {
      ProposalsTypeRequest.createProposalType(
        name,
        contentKey,
        approvalTemplateCode
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateProposalType = (id, name, contentKey, approvalTemplateCode) => {
    return new Promise((resolve, reject) => {
      ProposalsTypeRequest.updateProposalType(
        id,
        name,
        contentKey,
        approvalTemplateCode
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteProposalType = (id) => {
    return new Promise((resolve, reject) => {
      ProposalsTypeRequest.deleteProposalType(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}

const proposalTypeStore = new ProposalTypeStore();
export default proposalTypeStore;
